import { OVERLAY_ACTION_TYPES } from 'actionTypes/overlay';
import createAction from 'helpers/createAction';

export const toggleOverlay = createAction(OVERLAY_ACTION_TYPES.TOGGLE_OVERLAY);
export const hideAllOverlays = createAction(OVERLAY_ACTION_TYPES.HIDE_ALL_OVERLAYS);
